import { useQuery } from 'react-query';
import MembershipConsents from '../../services/MembershipConsent';
import { MEMBERSHIP_CONSENT } from '../../constants/reactQuery.keys';

export function useMembershipConsent(planId: number) {
  return useQuery([MEMBERSHIP_CONSENT, planId], () => MembershipConsents.getMembershipConsent({ planId }));
}
